import { ButtonPresentationProps } from "@insite/mobius/Button";
import { ModalPresentationProps } from "@insite/mobius/Modal";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";

export interface StoreMobileFiltersModalProps {
    modal?: ModalPresentationProps;
    modalTitleWrapper?: InjectableCss;
    modalTitle?: TypographyPresentationProps;
    buttonsWrapper?: InjectableCss;
    primaryButton?: ButtonPresentationProps;
    secondaryButton?: ButtonPresentationProps;
    mobileSortSelect?: SelectPresentationProps;
}

export const mobileFiltersModalProps: StoreMobileFiltersModalProps = {
    modal: {
        sizeVariant: "small",
        cssOverrides: {
            modalBody: css`
                padding-bottom: 120px;
            `,
            modalTitle: css`
                border-bottom: none;
                padding: 16px 20px 10px;
            `,
            modalContent: css`
                padding: 0 20px;
            `,
        },
        closeButtonProps: {
            css: css`
                padding: 0;
            `,
        },
        closeButtonIconProps: {
            size: 26,
        },
    },
    modalTitleWrapper: {
        css: css`
            padding-bottom: 14px;
        `,
    },
    modalTitle: {
        forwardAs: "h1",
        size: TYPOGRAPHY.size.larger,
        weight: TYPOGRAPHY.weight.black,
        lineHeight: TYPOGRAPHY.lineHeight.small,
    },
    buttonsWrapper: {
        css: css`
            display: flex;
            justify-content: center;
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            padding: 20px 0;
            box-shadow: ${getProp("theme.shadows.smallUp")};
            background-color: ${getColor("common.background")};
        `,
    },
    primaryButton: {
        variant: "primary",
        css: css`
            width: 100%;
            margin: 0 10px 0 20px;
        `,
    },
    secondaryButton: {
        variant: "secondary",
        css: css`
            width: 100%;
            margin: 0 20px 0 10px;
        `,
    },
    mobileSortSelect: {
        css: css`
            margin-bottom: 1em;
        `,
    },
};
